!(function () {
    "use strict";
    class t extends HTMLElement {
        constructor() {
            super(),
                (this.container = this.closest("[data-section-id]")),
                (this.images = this.querySelectorAll("[data-zoom-image]")),
                (this.zoomCaptions = this.container.querySelector("[data-zoom-caption]")),
                (this.thumbsContainer = document.querySelector(".pswp__thumbs"));
        }
        connectedCallback() {
            this.images.forEach((t, e) => {
                t.addEventListener("click", (o) => {
                    o.preventDefault(),
                        t.closest("product-images").classList.contains("is-dragging") ||
                            (this.createZoom(e), (window.a11y.lastElement = t));
                }),
                    t.addEventListener("keyup", (o) => {
                        "Enter" === o.code && (o.preventDefault(), this.createZoom(e), (window.a11y.lastElement = t));
                    });
            });
        }
        createZoom(t) {
            const e = this.container.querySelector("[data-pswp-thumbs-template]")?.innerHTML;
            let o = [],
                s = 0;
            this.images.forEach((i) => {
                const a = i.getAttribute("data-image-src");
                if (
                    ((s += 1),
                    o.push({
                        src: a,
                        w: parseInt(i.getAttribute("data-image-width")),
                        h: parseInt(i.getAttribute("data-image-height")),
                        msrc: a,
                    }),
                    this.images.length === s)
                ) {
                    const i = this.getColorScheme(),
                        a = {
                            history: !1,
                            focus: !1,
                            index: t,
                            mainClass: `pswp-zoom-gallery${1 === s ? " pswp-zoom-gallery--single" : ""}${i ? ` ${i}` : ""}`,
                            showHideOpacity: !0,
                            howAnimationDuration: 150,
                            hideAnimationDuration: 250,
                            closeOnScroll: !1,
                            closeOnVerticalDrag: !1,
                            captionEl: !0,
                            closeEl: !0,
                            closeElClasses: ["caption-close", "title"],
                            tapToClose: !1,
                            clickToCloseNonZoomable: !1,
                            maxSpreadZoom: 2,
                            loop: !0,
                            spacing: 0,
                            allowPanToNext: !0,
                            pinchToClose: !1,
                            addCaptionHTMLFn: (t, e, o) => {
                                this.zoomCaption(t, e, o);
                            },
                            getThumbBoundsFn: () => {
                                const e = this.images[t],
                                    o = window.scrollY || document.documentElement.scrollTop,
                                    s = e.getBoundingClientRect();
                                return { x: s.left, y: s.top + o, w: s.width };
                            },
                        };
                    new window.theme.LoadPhotoswipe(o, a),
                        this.thumbsContainer && "" !== e && (this.thumbsContainer.innerHTML = e);
                }
            });
        }
        zoomCaption(t, e) {
            let o = "";
            const s = e.children[0];
            return (
                this.zoomCaptions &&
                    ((o = this.zoomCaptions.innerHTML),
                    this.zoomCaptions.closest(".variant--soldout")
                        ? s.classList.add("variant--soldout")
                        : s.classList.remove("variant--soldout"),
                    this.zoomCaptions.closest(".variant--unavailable")
                        ? s.classList.add("variant--unavailable")
                        : s.classList.remove("variant--unavailable")),
                (s.innerHTML = o),
                !1
            );
        }
        getColorScheme() {
            const t = this.closest("product-info");
            return Array.from(t.classList).find((t) => t.startsWith("color-scheme"));
        }
    }
    customElements.get("zoom-images") || customElements.define("zoom-images", t);
})();
